import ky, { HTTPError } from "ky";
import { FormEventHandler, useState } from "react";

export const Login = () => {
  const [error, setError] = useState<string>("");
  const onSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const name = form["userName"].value;
    const password = form["password"].value;

    try {
      await ky.post("/api/login", { json: { name, password } });
      window.location.reload();
    } catch (e) {
      if (e instanceof HTTPError) {
        setError(await e.response.text());
        return;
      }
      setError((e as Error).message);
    }
  };
  return (
    <div className="container">
      <h2>Login</h2>
      <form onSubmit={onSubmit}>
        <input placeholder="Name" name="userName" />
        <input placeholder="Password" type="password" name="password" />
        {error ? <p className="container error">{error}</p> : null}
        <button>Login</button>
      </form>
    </div>
  );
};
